export enum GenericStatusEnum {
    Draft = 1,
    Sent = 2,
    Delivered = 3
}

export class GenericStatusEnumExtensions {
    static getColor(value: GenericStatusEnum): string {
        switch (value) {
            case GenericStatusEnum.Draft:
                return 'bg-element-selected text-on-app';
            case GenericStatusEnum.Sent:
                return 'bg-warn-light text-on-warn-light';
            case GenericStatusEnum.Delivered:
                return 'bg-success-light text-on-success-light';
        }
    }
}
